"use strict";

var _interopRequireDefault = require("/root/workspace/merchant_5Yxh/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.number.constructor");
var _user = require("@/api/user");
var _accounts = require("@/api/accounts");
var _index = require("@/utils/index");
var _auctionrecord = _interopRequireDefault(require("./auctionrecord"));
var _upauctionrecord = _interopRequireDefault(require("./upauctionrecord"));
var _nft = require("@/api/nft");
var _system = require("@/api/system");
var _fileList = _interopRequireDefault(require("@/components/exportFile/fileList"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'UserDetails',
  components: {
    auctionrecord: _auctionrecord.default,
    upauctionrecord: _upauctionrecord.default,
    fileList: _fileList.default
  },
  props: {
    uid: {
      type: Number,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    showdetail: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showview: false,
      moren: require('@/assets/images/f.png'),
      loading: false,
      columns: [],
      Visible: false,
      list: [{
        val: '0',
        label: '消费记录'
      }, {
        val: '3',
        label: '持有优惠券'
      }],
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 6
      },
      nftTableData: {
        data: [],
        total: 0
      },
      nftTableFrom: {
        page: 1,
        limit: 6,
        status: ''
      },
      psInfo: null,
      type: '0',
      drawtype: 'detail',
      userdetail: {},
      formatPriceNumber: _index.formatPriceNumber,
      listLoading: false,
      nftListLoading: false,
      userjson: {},
      showusercard: false,
      showImg: false,
      imgSrc: ''
    };
  },
  mounted: function mounted() {
    var _this = this;
    if (this.uid) {
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.nftTableFrom.own_uid = this.uid;
      (0, _user.getUserDetail)(this.uid).then(function (res) {
        _this.userdetail = res.data;
        _this.showview = true;
        loading.close();
      });
      this.tableFrom.uid = this.uid;
      // this.tableFrom.type = 'order';
      (0, _accounts.userWalletHistoryList)(this.tableFrom).then(function (res) {
        _this.tableData.data = res.data.list;
        _this.tableData.total = res.data.count;
        _this.listLoading = false;
      }).catch(function (res) {
        // this.$message.error(res.message);
        _this.listLoading = false;
      });
      this.getNft();
      // this.getHeader()
      // this.getInfo('0')
    }
  },

  methods: {
    changedrawtype: function changedrawtype(type) {
      this.drawtype = type;
    },
    showvimage: function showvimage(item) {
      this.userjson = item;
      this.showusercard = true;
    },
    changeshowdetail: function changeshowdetail() {
      this.$emit('close');
    },
    changeType: function changeType(key) {
      this.type = key;
      this.tableFrom.page = 1;
      this.getInfo(key);
    },
    getInfo: function getInfo(key) {
      var _this2 = this;
      this.loading = true;
      switch (key) {
        case '0':
          (0, _user.userOrderApi)(this.uid, this.tableFrom).then(function (res) {
            _this2.tableData.data = res.data.list;
            _this2.tableData.total = res.data.count;
            _this2.columns = [{
              title: '订单ID',
              key: 'order_id',
              minWidth: 250
            }, {
              title: '收货人',
              key: 'real_name',
              minWidth: 90
            }, {
              title: '商品数量',
              key: 'total_num',
              minWidth: 80
            }, {
              title: '商品总价',
              key: 'total_price',
              minWidth: 90
            }, {
              title: '实付金额',
              key: 'pay_price',
              minWidth: 90
            }, {
              title: '交易完成时间',
              key: 'pay_time',
              minWidth: 160
            }];
            _this2.loading = false;
          }).catch(function () {
            _this2.loading = false;
          });
          break;
        case '3':
          (0, _user.userCouponApi)(this.uid, this.tableFrom).then(function (res) {
            _this2.tableData.data = res.data.list;
            _this2.tableData.total = res.data.count;
            _this2.columns = [{
              title: '优惠券名称',
              key: 'coupon_title',
              minWidth: 120
            }, {
              title: '面值',
              key: 'coupon_price',
              minWidth: 120
            }, {
              title: '最低消费额',
              key: 'use_min_price',
              minWidth: 120
            }, {
              title: '兑换时间',
              key: 'use_time',
              minWidth: 120
            }];
            _this2.loading = false;
          }).catch(function () {
            _this2.loading = false;
          });
          break;
      }
    },
    pageChange: function pageChange(page) {
      var _this3 = this;
      this.tableFrom.page = page;
      (0, _accounts.userWalletHistoryList)(this.tableFrom).then(function (res) {
        _this3.tableData.data = res.data.list;
        _this3.tableData.total = res.data.count;
        _this3.listLoading = false;
      }).catch(function (res) {
        // this.$message.error(res.message);
        _this3.listLoading = false;
      });
      // this.getInfo(this.type)
    },
    handleSizeChange: function handleSizeChange(val) {
      var _this4 = this;
      this.tableFrom.limit = val;
      (0, _accounts.userWalletHistoryList)(this.tableFrom).then(function (res) {
        _this4.tableData.data = res.data.list;
        _this4.tableData.total = res.data.count;
        _this4.listLoading = false;
      }).catch(function (res) {
        // this.$message.error(res.message);
        _this4.listLoading = false;
      });
      // this.getInfo(this.type)
    },
    nftPageChange: function nftPageChange(page) {
      this.nftTableFrom.page = page;
      this.getNft();
    },
    nftHandleSizeChange: function nftHandleSizeChange(val) {
      this.nftTableFrom.page = 1;
      this.nftTableFrom.limit = val;
      this.getNft();
    },
    getNft: function getNft() {
      var _this5 = this;
      this.nftListLoading = true;
      (0, _nft.dataListApi)(this.nftTableFrom).then(function (res) {
        _this5.nftTableData.data = res.data.list;
        _this5.nftTableData.total = res.data.count;
        _this5.nftListLoading = false;
      }).catch(function (res) {
        // this.$message.error(res.message);
        _this5.nftListLoading = false;
      });
    },
    getHeader: function getHeader() {
      this.psInfo = this.row;
    },
    showImgAction: function showImgAction(img) {
      this.imgSrc = img;
      this.showImg = true;
    },
    // 导出
    exportOrder: function exportOrder() {
      var _this6 = this;
      var data = JSON.parse(JSON.stringify(this.nftTableFrom));
      data.export_type = 'nftData';
      (0, _system.exportexcel)(data).then(function (res) {
        // this.$message.success(res.message);
        // this.fileVisible = true;
        // this.$refs.exportList.exportFileList();
        var h = _this6.$createElement;
        _this6.$msgbox({
          title: '提示',
          message: h('p', null, [h('span', null, '文件正在生成中，请稍后点击"'), h('span', {
            style: 'color: teal'
          }, '导出记录'), h('span', null, '"查看~ ')]),
          confirmButtonText: '我知道了'
        }).then(function (action) {});
      }).catch(function (res) {
        // this.$message.error(res.message);
      });
    },
    getExportFileList: function getExportFileList() {
      this.fileVisible = true;
      this.$refs.exportList.exportFileList('nftData');
    },
    goOrderAction: function goOrderAction() {
      if (this.$route.name === 'AuctionMeetingOrder') {
        this.$emit('editPhone', this.userdetail.phone);
      } else {
        this.$router.push("/merchant/order/list/auctionMeeting?user_phone=".concat(this.userdetail.phone));
      }
    }
  }
};
exports.default = _default;